import { Component, OnDestroy } from '@angular/core';
import { AppSettings } from 'app/service/app-settings.service';

@Component({
  selector: 'app-page401',
  templateUrl: './page401.component.html',
})
export class Page401Component implements OnDestroy {

  constructor(public appSettings: AppSettings) {
    this.appSettings.appEmpty = true;
  }

  ngOnDestroy() {
    this.appSettings.appEmpty = false;
  }
}
